import { onboardingRouteFor } from "./onboardingRoutes";

// The one mapping from a user's role to the screen they land on. Post-OTP
// navigation (Verification.jsx) and the role-mismatch redirect in the route
// guards must agree on this, or a bounced user can ping-pong between guards —
// so both read it from here.
export function getLandingRouteForUser(user) {
  const userType = user?.userType;

  if (userType === "advisor") return "/inbox";
  if (userType === "admin" || userType === "super-admin") return "/admin-dashboard";
  if (userType === "client") {
    // Pooled inbox SP3 (R129): a stage with a page of its own lands there;
    // any other stage, or none, keeps the legacy client leg below.
    const onboardingPath = onboardingRouteFor(user?.onboardingStage);
    if (onboardingPath) return onboardingPath;
    // Pooled inbox SP4 (R207/R208): any stage after intake, and a client with
    // no stage the server lists, land on the dashboard. /welcome is You're in,
    // reached only through trial_start's route — it is gated on that stage, so
    // landing a stage-less client there would loop (gate → landing → gate).
    return "/dashboard";
  }

  // Unrecognised role: /login is the only target guaranteed not to be behind a
  // role guard, so it can't produce a redirect loop.
  return "/login";
}
